import EventPost from 'flarum/forum/components/EventPost';
import { statusOf, StatusLabel } from '../../common/sublace';

/** Служебное сообщение «… сменил(а) статус на …». */
export default class StatusChangedPost extends EventPost {
  icon() {
    return 'fas fa-tag';
  }
  descriptionKey() {
    return this.attrs.post.content().after ? 'sublace-forum.forum.post_stream.status_changed_text' : 'sublace-forum.forum.post_stream.status_removed_text';
  }
  descriptionData() {
    const content = this.attrs.post.content() || {};
    const status = statusOf(content.after) || (content.after ? {
      label: content.label || content.after,
      color: content.color || '#9890a5',
      icon: ''
    } : null);
    return {
      status: status ? m(StatusLabel, {
        status: status,
        small: true
      }) : ''
    };
  }
}
flarum.reg.add('sublace-forum', 'forum/components/StatusChangedPost', StatusChangedPost);